import { apiClient, getUserId } from "./authService";

export type PromoData = { [key: string]: any };

export const validateAppointment = async (AppointmentData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/business/validate", AppointmentData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllAppointments = async (business_id: string, options?: { viewType?: 'day' | 'week' | 'month', isVenue?: boolean }): Promise<any> => {
  try {
    const params = new URLSearchParams();
    if (options?.viewType) params.append('viewType', options.viewType);
    const query = params.toString() ? `?${params.toString()}` : '';
    
    if (options?.isVenue) {
      const response = await apiClient.get(`/appointments/getVenueAppointments/${business_id}${query}`);
      return response.data;
    } else if (options?.viewType === 'week' || options?.viewType === 'month') {
      const response = await apiClient.get(`/appointments/${business_id}/1`);
      return response.data;
    } else {
      // For day view, call both APIs simultaneously
      const [todayResponse, allResponse] = await Promise.all([
        apiClient.get(`/appointments/getToday/${business_id}${query}`),
        apiClient.get(`/appointments/${business_id}/1`)
      ]);
      
      return {
        today: todayResponse.data,
        all: allResponse.data
      };
    }
  } catch (error) {
    throw error;
  }
};

export const getAppointmentsRevenue = async (
  venueId: string,
  startDate: string,
  endDate: string
): Promise<any> => {
  try {
    const response = await apiClient.post(
      `/appointments/revenue/${venueId}`,
      {
        start_date: startDate,
        end_date: endDate,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createAppointment = async (
  appointmentData: PromoData | FormData
): Promise<any> => {
  try {
    const userId = getUserId();

    if (appointmentData instanceof FormData) {
      if (!appointmentData.has("user_id") && userId) {
        appointmentData.append("user_id", userId);
      }
      console.log("Appointment Data FormData:", appointmentData);
      const response = await apiClient.post("/appointments/create", appointmentData);
      return response.data;
    } else {
      const payload = { ...(appointmentData || {}) };
      if (!payload.user_id && userId) {
        payload.user_id = userId;
      }
      const response = await apiClient.post("/appointments/create", payload);
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateAppointment = async (
  id: string,
  appointmentData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/appointments/editAppt/${id}`, appointmentData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAppointment = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/appointments/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changeAppointmentStatus = async (
  id: string,
  status: string
): Promise<any> => {
  try {
    const response = await apiClient.put(`/appointments/changeStatus/${id}`, {
      status,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
